import type { ID } from '../types';
import Occasion from '../helpers/Occasion';

const idCounter: { [key: string]: number } = {};
const getTempId = (prefix: string): string => {
  const id = (idCounter[prefix] || 0) + 1;
  idCounter[prefix] = id;
  return `temp_${prefix}_${id}`;
};

export default class BaseObject {
  id?: ID;
  isFetching?: boolean;
  updated?: Occasion;
  error?: any;
  isDeleting?: boolean;

  constructor(props: any) {
    this.id = (props.id || getTempId(this.constructor.name)).toString();
    this.isFetching = props.isFetching || false;
    this.updated = props.updated || null;
    this.error = props.error || null;
    this.isDeleting = props.isDeleting || false;
  }

  copyWith(props: Object): any {
    // @ts-ignore: allow subclasses to call their own constructor implementations
    return new this.constructor({ ...this, ...props });
  }

  isEqual(obj: BaseObject): boolean {
    return obj && this.id == obj.id;
  }

  get isLoaded(): boolean {
    return !this.isFetching && this.updated != null;
  }

  get isPersisted(): boolean {
    return !/^temp_/.test(this.id.toString());
  }

  get toObj() {
    return { ...this };
  }
}
